import script from "./TradesPlus.vue?vue&type=script&lang=js"
export * from "./TradesPlus.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__